<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="700px">
            <v-card>
                    <v-toolbar dark color="blue lighten-2">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Выбор обложки для группы</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip>
                            <template v-slot:activator="{ on }">
                                <v-btn dark icon  v-on="on" @click="updateImages">
                                    <v-icon>refresh</v-icon>
                                </v-btn>
                            </template>
                            <span>Обновить медиатеку</span>
                        </v-tooltip>
                        <v-tooltip>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        v-on="on"
                                        icon
                                        @click="sendNotification"
                                        dark
                                > <!--href="https://vk.com/write-23067124" target="_blank" link>-->
                                    <v-icon>cloud_upload</v-icon>
                                </v-btn>
                            </template>
                            <span>Перейти в диалог группы ВК и залить файлы</span>
                        </v-tooltip>
                    </v-toolbar>
                <v-list subheader class="content">
                    <v-container
                            grid-list-sm
                            class="pa-2"
                    >
                        <v-item-group
                                multiple
                        >
                            <v-layout wrap>
                                <v-flex
                                        v-for="mediaItem in mediaItems"
                                        :key="mediaItem.id"
                                        xs12
                                        md3
                                >
                                    <v-img
                                            v-if="mediaItem.visible == 1"
                                            :src="mediaItem.link"
                                            height="120"
                                            class="text-right pa-2"
                                            @click="$emit('selectImage', mediaItem.link)"
                                    >
                                    </v-img>
                                </v-flex>
                            </v-layout>
                        </v-item-group>
                    </v-container>
                </v-list>
                <v-card-actions v-if="model.image !== null">
                    <v-container fluid>
                        <v-row>
                            <span class="ma-2 pa-2">Выбранная обложка</span>
                        </v-row>
                        <v-row justify="center">
                            <v-col cols="12" md="5">
                                <v-img
                                        :src="model.image"
                                        height="120"
                                        class="text-right ma-2 pa-2"
                                        @click="$emit('selectImage', null)"
                                >
                                </v-img>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import axios from 'axios'
import constConf from '../../../constconf.js'
import { mapGetters } from 'vuex'
export default {
    name: 'SelectImage',
    data () {
        return {
            mediaItems: []
        }
    },
    props: ['visible', 'model'],
    methods: {
        updateImages() {
            axios.defaults.withCredentials = true
            axios.get(constConf.message.url + '/medialibrary/type/' + this.model.bot_id + '?type=0').then(response => {
                this.mediaItems = response.data
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
        },
        sendNotification() {
            let bot = this.bot(+this.$route.params['pathMatch'])
            let url = 'https://vk.com/gim' + bot.group_id + '?sel=' + this.user.id
            // 'https://vk.com/write-' + bot.group_id, '_blank'
            window.open(url)
            axios.defaults.withCredentials = true
            axios.get(constConf.message.url + '/send/service-vk/' + 1 + '?bot_id=' + bot.id).then(response => {
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error get medialibrary ' + error)
            })
        }
    },
    created() {
        this.updateImages()
    },
    computed: {

        show: {
            get() {
                return this.visible
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        },
        ...mapGetters({
            bot: 'bots/getBotById',
            bots: 'bots/bots',
            user: 'user/user'
        })
    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active ;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }
    .container {
        display: flex;
        flex-direction: column;
    }
</style>
